import React from 'react'
import {QrReader}  from 'react-qr-reader'
import "./ScanQR.scss"
const ScanQR = (props) => {

    // const [QRCode, setQRCode] = useState(null)

    // const AllQRCode = items.[10]
    // const detectedItem = AllQRCode.find(item => item.name === "دوربین بولت 3mp-4140");
    // console.log(detectedItem);


    // const handleError = () => {
    //     alert('دسترسی به دوربین مسدود شده است!')
    // }

    // const handleScan = data => {
    //     if (data) {
    //         setQRCode(data)
    //     }
    // }

    // setTimeout(() => {
    //     setQRCode("دوربین")
    // }, 3000);
    // const onLoad = () => {
    //     mirrorVideo=true,
    //         streamLabel = sssss
    // }

    return (
        <div className="page-content-center qrcode-container">
            <QrReader 
                delay={300}
                resolution={1000}
                showViewFinder={false}
                onError={props.handleError}
                onScan={props.onScan}
                className="QrScan"
                // legacyMode={true}
                // onLoad={
                //     mirrorVideo = "true",
                //     streamLabel = "sssss"
                // }
            />

        </div>
    )
}

export default ScanQR